export default __webpack_public_path__ + "static/media/pregnantBlack.7d52f4fb.svg";